import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the TaskScannerScreen state domain
 */

const selectTaskScannerScreenDomain = state =>
  state.taskScannerScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by TaskScannerScreen
 */

const makeSelectTaskScannerScreen = () =>
  createSelector(
    selectTaskScannerScreenDomain,
    substate => substate,
  );

export default makeSelectTaskScannerScreen;
export { selectTaskScannerScreenDomain };
